import { getEtMarketDateKey, isUsEquityTradingDay } from '../marketSession.js'
import { millisecondsUntilDailyClose } from '../marketRegime.js'
import { calculateExposureSeries, validateExposureSessions } from './v1.js'

function adjacentSession(session, direction) {
  const date = new Date(`${session}T16:00:00Z`)
  do { date.setUTCDate(date.getUTCDate() + direction) } while (!isUsEquityTradingDay(date))
  return getEtMarketDateKey(date)
}

export function exposureSessionWindow(now = new Date()) {
  if (!(now instanceof Date) || !Number.isFinite(now.getTime())) throw new Error('Invalid observation time')
  const today = getEtMarketDateKey(now)
  const signalSession = isUsEquityTradingDay(now) && millisecondsUntilDailyClose(now) === 0
    ? today : adjacentSession(today, -1)
  return { signalSession, effectiveSession: adjacentSession(signalSession, 1) }
}

// Pure time/session selection. A ready calculation is NOT a provider freshness
// certificate: ingestion must separately establish adjustment, finality,
// permissions and availability. Keep the last valid result explicitly separate.
export function completedExposureGuidance(rows, { now = new Date() } = {}) {
  const { signalSession, effectiveSession } = exposureSessionWindow(now)
  // Validate ordering even for future/provisional rows; never sort ambiguity away.
  validateExposureSessions(rows)
  const completed = rows.filter(row => row.session <= signalSession)
  const series = calculateExposureSeries(completed)
  const latest = series.at(-1) || null
  const signal = latest?.session === signalSession && latest.status === 'ready' ? latest : null
  const lastValid = [...series].reverse().find(row => row.status === 'ready') || null
  return { status: signal ? 'ready' : 'unavailable', signalSession, effectiveSession, signal, lastValid }
}
